//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from "vuex";
export default {
  name: "NUTRIC",
  data() {
    return {
      form: {
        value1: "",
        value2: "",
        value3: "",
        value4: "",
        value5: "",
        value6: "",
      },
      hasScore: false,
      disabled: false,
      dataList: [
        { value: "0", name: "＜50岁" },
        { value: "1", name: "50-74岁" },
        { value: "2", name: "≥75岁" },
      ],
      dataList1: [
        { value: "0", name: "＜15" },
        { value: "1", name: "15-19" },
        { value: "2", name: "20-27" },
        { value: "3", name: "≥28" },
      ],
      dataList2: [
        { value: "0", name: "＜6" },
        { value: "1", name: "6-9" },
        { value: "2", name: "≥10" },
      ],
      dataList3: [
        { value: "0", name: "0-1" },
        { value: "1", name: "≥2" },
      ],
      dataList4: [
        { value: "0", name: "少于1天" },
        { value: "1", name: "多于1天" },
      ],
      dataList5: [
        { value: "0", name: "≤400" },
        { value: "1", name: "＞400" },
      ],
    };
  },
  created() {
    this.hideLoad();
  },
  methods: {
    ...mapMutations(["hideLoad"]),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this;
      let form = JSON.parse(JSON.stringify(self.form));
      let flag = true;
      let result = 0;
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false;
          } else {
            form[key] = Number(form[key]);
          }
        }
        result += Number(form[key]);
      }
      if (!flag) {
        self.hasScore = false;
        return "";
      } else {
        self.hasScore = true;
        return {
          result:String(result),
          result1:String(result > 1?result - 1 :0)
        };
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/NUTRIC.vue